<!--报警管理-->
<template>
  <Card
    dis-hover
    class="contentArea"
    style="position: relative; background: #fff"
  >
    <packageTable
      ref="contentBaseRef"
      class="contentBaseRef noHeaderTable"
      tableName="alermDes"
      :tableData="tableData"
      rowKey="id"
      :columnsData="columnsData"
      :loading="tableLoading"
      :tabletotallen="tabletotallen"
      :reduceheight="reduceheight"
      :border="border"
      :stripe="stripe"
      :showSearch="false"
      :showSearchBtn="false"
      :showTableHeader="true"
      :tablePageSize="reqBase.page_size"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @showSearchParel="showSearchParel"
      @refreshBtn="init"
      @getSelect="idSelectChange"
    >
      <template slot="search">
                <Col span="6">
          <FormItem :label="this.$t('devicelist.region')">
            <Select v-model="form_filter.country_code" filterable>
              <Option
                v-for="(item, i) in statusData3"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.did')">
            <Input
              type="text"
              :disabled="hasDid ? true : false"
              v-model="form_filter.did"
              :placeholder="this.$t('devicelist.deviceidfiltering')"
            />
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="this.$t('devicelist.date')" prop="date">
            <DatePicker
              :value="form_filter.date"
              style="width: 100%"
              @on-change="changeTime"
              type="date"
              format="yyyy-MM-dd"
              :placeholder="this.$t('devicelist.datechoose')"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col span="6">
          <Button
            v-for="(item, index) in topButtonList"
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            >{{ item.name }}</Button
          >
        </Col>
      </template>
      <template slot="headRight">
        <Tooltip
          v-for="(item, index) in headBtnList1"
          :key="index"
          :content="item.name"
          placement="bottom"
        >
          <Button
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            :icon="item.icon"
            >{{ item.name }}</Button
          >
        </Tooltip>
      </template>
      <!-- <div slot="footer">
        <Button type="primary" @click="prevpage()">上一页</Button>
        <Button type="primary" @click="nextpage()" style="margin-left:10px;">下一页</Button>
      </div> -->
    </packageTable>
    <addCom
      :showModal="showAddModal"
      className="vertical-center-modal"
      :ids="ids"
      :parent_name="parent_name"
      :editData="editData"
      :editModal="editModal"
      :title="modalTitle"
      :parent_code="parent_code"
    ></addCom>
    <handleCom
      :showModal="showHandleModal"
      className="vertical-center-modal"
      :parent_name="parent_name"
      :editData="editData"
      :editModal="editModal"
      :title="modalTitle"
      :parent_code="parent_code"
    ></handleCom>
  </Card>
</template>

<script>
import packageTableMixins from "@/mixins/packageTableMixins.js";
import {
  alarm_list,
  merchant_del,
  get_merchant_all,
  get_downloadtoken,
} from "@/api/jingxiaoshang";
import addCom from "./components/addCom";
import handleCom from "./components/handleCom";
import { getcurrDate } from "@/libs/util";
import { commonReq } from "@/api/common.js";
import axios from "axios";
import config from "@/config/index";
import downloadHistory from "../../deviceman/devicedistribution/components/downloadHistory.vue";
// import viewVideo from './components/viewVideo'
export default {
  name: "project",
  mixins: [packageTableMixins],
  data() {
    return {
      merchantData: [],
      showVideoModal: false,
      //模拟数据列表
      switchList: {},
      merchant_list: [],
      statuslist: [
        { name: this.$t("alarmmenu.nothandle"), value: 1 },
        { name: this.$t("alarmmenu.okhandle"), value: 2 },
      ],
      //共用的查询与重置
            statusData3: [
        { value: "xciot-prod-cnsz", name: this.$t("Changelang.中国") },
        { value: "xciot-prod-hk", name: this.$t("Changelang.香港") },
        { value: "xciot-prod-us2", name: this.$t("美国") },
        { value: "xciot-prod-eu", name: this.$t("Changelang.欧洲") },
      ],
      topButtonList: [
        {
          name: this.$t("query"),
          type: "primary",
          method: this.search,
        },
        {
          name: this.$t("reset"),
          type: "error",
          method: this.reset,
        },
      ],
      ids: [],
      parent_name: null,
      editData: null,
      editModal: false,
      modalTitle: "新增",
      parent_code: null,
      reduceheight: 78,
      showAddModal: false,
      showHandleModal: false,
      headBtnList: [
        {
          name: "查询",
          type: "primary",
          method: this.search,
        },
        {
          name: "重置",
          type: "error",
          method: this.reset,
        },
      ],
      headBtnList1: [
        {
          name: this.$t("export"),
          icon: "ios-download",
          type: "primary",
          method: this.export,
        },
        // {
        //   name: this.$t('refresh'),
        //   icon: 'ios-refresh',
        //   type: 'primary',
        //   method: this.init
        // }
      ],
      moduleData: [], //模块
      stateData: [
        {
          value: -1,
          label: "全部",
        },
        {
          value: 0,
          label: "禁用",
        },
        {
          value: 1,
          label: "启用",
        },
      ],
      form_filter: {
        // merchant_code:null,
        // status: null,
        // alarm_level:null
        did: null,
        date: null,
        start_time: null,
        end_time: null,
        country_code: null,
      },
      searchReq: {
        mods: [],
      },
      tableData: [],
      columnsData: [
        // {
        //   title: '多选',
        // //  key: 'id',
        //   align: 'center',
        //   width: 100,
        //   type: 'selection'
        // },
        // {
        //   title: '序号',
        //   key: 'id',
        //   align: 'center',
        //   width:100
        // },
        {
          title: this.$t("alarmmenu.did"),
          key: "device_id",
          align: "center",
        },
        {
          title: this.$t("alarmmenu.affiliatedagent"),
          key: "shop_name",
          align: "center",
        },
        {
          title: this.$t("alarmmenu.datatype"),
          key: "data_type_name",
          align: "center",
        },
        {
          title: this.$t("alarmmenu.address"),
          key: "addr_name",
          align: "center",
        },

        {
          title: this.$t("alarmmenu.alarmcause"),
          key: "alarm_type_name",
          align: "center",
        },
        {
          title: this.$t("alarmmenu.alarmtime"),
          key: "alarm_time",
          align: "center",
        },
        // {
        //   title: this.$t('alarmmenu.status'),
        //   key: 'status',
        //   align: 'center',
        //   render: (h, { row }) => {
        //     let result = ""
        //     let color=''
        //     if (row.status === 1) {
        //       color="error"
        //       result=this.$t('alarmmenu.nothandle')
        //     } else if (row.status === 2) {
        //       color="primary"
        //       result=this.$t('alarmmenu.okhandle')
        //     }
        //     return h('Tag',{
        //         props:{
        //           color
        //         }
        //       },result)
        //   }
        // },

        // {
        //   title: this.$t('alarmmenu.handleuser'),
        //   key: 'handle_user_name',
        //   align: 'center',
        // },
        // {
        //   title: this.$t('alarmmenu.handletime'),
        //   key: 'handle_user_time',
        //   align: 'center',
        // },
        // {
        //   title: this.$t('operation'),
        //   key: 'explain',
        //   align: 'center',

        //   width:180,
        //     render: (h, { row }) => {
        //         let arr = [
        //         ];

        //         if (row.status === 1) {
        //         arr.push(h("Button",{
        //         style:{
        //           marginRight:"3px",
        //           marginBottom:"3px",
        //           color:'#2d8cf0',
        //         },
        //         props:{
        //           size:"small",
        //           type:'text',
        //         },
        //         on:{
        //           "click":()=>{
        //             this.handleModuleShow(row);
        //           }
        //         }
        //       },this.$t('alarmmenu.handle')))
        //           }

        //     let but = h("div",arr);

        //     return but;
        //   }
        // }
      ],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: "",
      },
      reqBase: {
        page: 1,
        type: 1,
      },
      states: [
        {
          value: 0,
          label: "禁用",
        },
        {
          value: 1,
          label: "启用",
        },
      ],
    };
  },
  props: {
    hasDid: {},
  },
  components: {
    addCom,
    handleCom,
  },
  computed: {},
  methods: {
    export(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  vm.$t("exportTime")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h(downloadHistory, {
              ref: "downloadHistory",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                projectCode: this.code,
                dids: this.dids,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.downloadHistory;
          obj.checkForm().then((req) => {
            if (vm.form_filter.did) {
              if (req) {
                let formModel = obj.formModel;
                let domain = vm.get_domain();
                let lang =
                  localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
                get_downloadtoken({ type: "2" }).then((res) => {
                  _this.buttonLoading = false;
                  if (res.result === 0) {
                    let downloadtoken = res.body.downloadtoken;
                    let params =
                      "?type=2&downloadtoken=" +
                      downloadtoken +
                      "&did=" +
                      vm.form_filter.did +
                      "&time_start=" +
                      formModel.start_time +
                      "&time_end=" +
                      formModel.end_time +
                      "&lang=" +
                      lang;
                    console.log(
                      domain + "/index.php/admin/device/history_daochu" + params
                    );
                    window.open(
                      domain + "/index.php/admin/device/history_daochu" + params
                    );

                    vm.$Modal.remove();
                  } else {
                    vm.$Message.error(res.errorMsg);
                  }
                });
              } else {
                _this.buttonLoading = false;
              }
            } else {
              _this.$Message.error(vm.$t("请选择导出设备") + "ID");
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    get_domain() {
     let result = "";
      let country_code = localStorage.getItem("country_code");
      result =
        country_code === "xciot-prod-cnsz"
          ? "https://bms-api.xcthings.com"
          : country_code === "xciot-prod-hk"
          ? "https://bms-hk-api.xcthings.com"
          : country_code === "xciot-prod-us2"
          ? "https://bms-us-api.xcthings.com"
          : "https://bms-eu-api.xcthings.com";
      return result;
    },
    changeTime(val) {
      this.$set(this.form_filter, "date", val);
    },
    getMerchantData() {
      console.log(111);
      this.merchantData.splice(0);
      get_merchant_all().then((res) => {
        if (res.result === 0) {
          console.log(data);
          let data = res.body;
          this.checkTree(data);
          // console.log('a',data)
          this.merchantData = data;
        }
      });
    },
    checkTree(arr) {
      for (let i in arr) {
        if (arr[i].shop_name) {
          arr[i].value = arr[i].merchant_code;
          arr[i].label = arr[i].shop_name;
          arr[i].title = arr[i].shop_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }
        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          arr[i].children.push(...arr[i].children_shop);
        }
        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },

    changeSwitch(val, id, index) {
      console.log(val);
      if (this.switchList.hasOwnProperty(id)) {
        this.$set(this.switchList[id], index, val);
      } else {
        this.$set(this.switchList, id, {});
        this.$set(this.switchList[id], index, val);
      }
      localStorage.setItem("switchList", JSON.stringify(this.switchList));
    },
    idSelectChange(SelectItem) {
      this.ids.splice(0);
      if (SelectItem && SelectItem.length > 0) {
        for (let i in SelectItem) {
          let list = SelectItem[i];
          this.ids.push(list.id);
          // this.ids = list.id
        }
      }
      console.log(this.ids);
    },
    reset() {
      this.form_filter = {
        did: null,
        date: null,
        start_time: null,
        end_time: null,
         country_code:localStorage.getItem("country_code"),
      };
      this.form_filter.type = "";
      this.search();
    },
    search() {
      this.form_filter.type = "";
      console.log("this.form_filter", this.form_filter);
      this.onSearch(this.form_filter);
    },
    onSearch(params) {
      //重置当前页为1
      this.reqBase.page = 1;
      this.reqBase.time_end = "";
      this.reqBase.time_start = "";
      Object.assign(this.reqBase, params);
      //重置当前的page
      //this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },
    init() {
        this.form_filter.country_code=localStorage.getItem("country_code")
      if (this.form_filter.date == "") {
        this.form_filter.date = getcurrDate();
        this.reqBase.date = this.form_filter.date;
      }

      if (this.$route.query.did) {
        this.form_filter.did = this.$route.query.did;
        this.reqBase.did = this.$route.query.did;
      }
      // debugger
      // this.getMerchantData();
      this.getPageSizeToStorage();
      this.getData();
    },
    /**
     * 初始化数据
     */
    getData() {
      this.reqBase.date = this.form_filter.date;
      this.tableLoading = true;
      const vm = this;
      //;
      let callbak = (res) => {
        this.tableLoading = false;

        if (res.result === 0) {
          vm.tableData = res.body.list || [];

          let len = vm.tableData.length;
          if ("type" in this.reqBase && this.reqBase.type != "") {
            console.log("yes");
            let prev_pages = localStorage.getItem("prev_time");
            let prev_pages2 = JSON.parse(prev_pages);
            prev_pages2.push(vm.tableData[len - 1].time);
            localStorage.setItem("prev_time", JSON.stringify(prev_pages2));
          } else {
            let prev_pages = [];
            prev_pages.push(0);
            prev_pages.push(vm.tableData[len - 1].time);
            localStorage.setItem("prev_time", JSON.stringify(prev_pages));
          }
          localStorage.setItem("time_end", vm.tableData[len - 1].time);

          vm.tabletotallen = res.body.total;
        } else {
          if (res.errorMsg == "数据为空") {
            this.$Message.error(res.errorMsg);
            return;
          }

          vm.tableData = [];
          this.$Message.error(res.errorMsg);
        }
      };
      let state = this.reqBase.state;
      if (this.reqBase.state === -1) {
        state = "";
      }
      let mod_code = this.reqBase.mod_code;
      if (this.reqBase.mod_code == -1) {
        mod_code = "";
      }
      console.log("我的查询条件", { ...this.reqBase, state, mod_code });
      // return;
      commonReq("/index.php/admin/alarm/new_alarm_list", {
        ...this.reqBase,
        state,
        mod_code,
      })
        .then((res) => {
          callbak(res);
        })
        .catch((err) => {
          this.tableLoading = false;
        });

      // //商户列表
      // merchant_list({
      //               page: 1,
      //               page_size: 100000000,
      //               type: localStorage.getItem('account_type')
      //             }).then(res => {
      //               if(res.result===0){
      //                 this.merchant_list = res.body.list || [];
      //                  console.log(res.body.list)
      //                 //this.$parent.init()
      //                 //this.handleReset(this.formName)
      //                 //this.onCancel()
      //               }else{
      //                 this.$Message.error(res.errorMsg)
      //                 this.backStatus()
      //               }
      //             }).catch(()=>{
      //               this.backStatus()
      //             })
    },
    /**
     * 重置搜索框
     */
    resetSearch() {
      this.searchReq = {
        mods: [],
      };
    },
    okSearch() {
      Object.assign(this.reqBase, this.searchReq);
      //重置当前页为1
      this.reqBase.page = 1;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },
    /**
     * 翻页
     */
    pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },
    /**
     * 筛选
     */
    showSearchParel() {
      this.$refs.search.expandPanel();
    },
    /**
     * 控制模态框显示隐藏
     * type 显示隐藏
     * handle true新增 false编辑
     * row 本条数据
     */
    addModuleShow() {
      this.modalTitle = this.$t("alarmmenu.batchprocessing");
      this.parent_code = "";
      this.parent_name = this.$t("alarmmenu.nodata");
      this.editModal = false;
      this.ids = this.ids;
      this.showAddModal = !this.showAddModal;
    },
    handleModuleShow(row) {
      this.modalTitle = this.$t("alarmmenu.alarmhandle"); //'告警处理'
      this.parent_code = "";
      this.parent_name = this.$t("alarmmenu.nodata");
      this.editModal = true;
      this.editData = row;
      this.showHandleModal = !this.showHandleModal;
    },
    addChild(row) {
      this.modalTitle = this.$t("alarmmenu.handle");
      this.editModal = false;
      this.parent_code = row.area_code;
      this.parent_name = row.area_name;
      this.showAddModal = !this.showAddModal;
    },
    edit(row) {
      this.editData = row;
      this.showVideoModal = !this.showVideoModal;
    },

    /**
     * 删除
     */
    delModule(row) {
      const _this = this;
      let config = {
        loading: true,
        title: "删除",
        width: 400,
        content: `<p>确认删除<span style="color: #f60;">${row.area_name}</span>？</p>`,
        onOk: () => {
          let params = {
              merchant_code: row.merchant_code,
            },
            callbak = (req) => {
              if (req.result === 0) {
                this.$Message.success(this.$t("删除成功！"));
                this.$Modal.remove();
                this.init();
              } else {
                this.buttonLoading = false;
                this.$Message.error(req.errorMsg);
              }
            };
          //删除接口
          merchant_del(params).then((res) => {
            callbak(res);
          });
        },
      };
      this.$Modal.confirm(config);
    },
  },
  async mounted() {
    if (this.$route.query && this.$route.query.did) {
      this.form_filter.did = this.$route.query.did;
      this.reqBase.did = this.$route.query.did;
    }
    window.onresize = () => {
      //  this.changeTableHeight()
    };
    this.$nextTick(() => {
      let innerWidth = window.innerHeight - 66;
      this.treeHeight = innerWidth;
      // this.changeTableHeight()
      //显示标记的数据
      // let switchList=localStorage.getItem('switchList')
      //  if(switchList){
      //    this.$set(this,'switchList',JSON.parse(switchList))
      // }
    });
    this.init();
  },
  created() {
    this.form_filter.date = getcurrDate();
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped>
.w6 {
  width: calc(25% - 10px);
  margin-left: 5px;
  margin-right: 5px;
}

.ivu-picker-confirm-time {
  background: #fff;
}

.handle_operation {
  float: right;
  margin-right: 50px;
  margin-top: -39px;
}
</style>
